import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { Asset } from 'assets-model';
import { TransferAsset } from 'assets-model';
import { BusinessUnit, BUSINESS_UNIT_METADATA, CostCentre, COST_CENTRE_METADATA } from 'assets-model';
import { AssetsUserStorage, BusinessUnitService, CostCentreService, TransferAssetService } from 'assets-service';

@Component({
  templateUrl: './transfer-asset-dialog.component.html',
  styleUrls: ['./transfer-asset-dialog.component.css']
})
export class TransferAssetDialogComponent {
  businessUnitSelectionList: BusinessUnit[];
  costCentreSelectionList: CostCentre[];
  businessUnit: BusinessUnit;
  costCentre: CostCentre;
  asset: Asset;
  comments: string;
  form: FormGroup;

  constructor(private dialogRef: MatDialogRef<TransferAssetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private transferAssetService: TransferAssetService,
    private businessUnitService: BusinessUnitService,
    private costCentreService: CostCentreService,
    protected userStorage: UserStorage,
    protected snackbar: MatSnackBar,
    private fb: FormBuilder) {
    this.asset = data.asset;
  }

  ngOnInit() {
    this.businessUnitLoadSelectionList();
    this.form = this.createForm();
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll(false).subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }

  businessUnitChanged() {
    if (this.businessUnit) {
      this.costCentreLoadSelectionList(this.businessUnit.buId);
    }
  }

  compareBusinessUnit(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }


  costCentreLoadSelectionList(businessUnitId: String) {
    var filters = { buId: businessUnitId }
    this.costCentreService.findByFullFilters(filters).subscribe(
      data => {
        this.costCentreSelectionList = data.items.filter(c => !COST_CENTRE_METADATA.equals(c, this.asset.costCentre));
      }
    );
  }

  costCentreChanged() {
  }


  costCentreCompare(a: any, b: any) {
    return COST_CENTRE_METADATA.equals(a, b);
  }

  createTransferAsset() {
    var transferAsset = new TransferAsset();
    transferAsset.businessUnit = this.businessUnit;
    transferAsset.comments = this.comments;
    transferAsset.asset = this.asset;

    if (this.costCentre != null) {
      transferAsset.costCentre = this.costCentre;
    }

    this.transferAssetService.create(transferAsset).subscribe(data => {
      this.snackbar.open("Asset transfer created", "OK", { duration: 10000 });
      this.closeDialog();
    });
  }

  isCreateTransferEnabled() {
    return !this.form.invalid;
  }

  createForm(): FormGroup {
    return this.fb.group({
      businessUnit: [null, [requiredValidator]],
      comments: [null, [requiredValidator]],
      costCentre: []
    });
  }

}
